import { RequestId } from '../../components/utilities/Table/generalColumns/RequestId';
import { ClientIdentification } from '../../components/utilities/Table/generalColumns/ClientIdentification';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';
import { ExecutiveWithTooltip } from '../../components/utilities/Table/generalColumns/ExecutiveWithTooltip';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { ResponsableWithTooltip } from '../../components/utilities/Table/generalColumns/ResponsableWithTooltip';
import { AmountRequest } from '../../components/utilities/Table/generalColumns/AmountRequest';
import { AnalistWithTooltip } from '../../components/utilities/Table/generalColumns/AnalistWithTooltip';
import { ApproverWithTooltip } from '../../components/utilities/Table/generalColumns/ApproverWithTooltip';
import { CausalRequest } from '../../components/utilities/Table/generalColumns/CausalRequest';
// import { KivaRequest } from '../../components/utilities/Table/generalColumns/KivaRequest';

const commonColumns = [
    RequestId,
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    OfficeRequest,
    ClientIdentification,
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    ExecutiveWithTooltip,
    StatusWithTooltip,
];

const requestsListStatus = [
    {
        id: ' en_proceso',
        label: ' EN PROCESO',
        status: '10,20,30,40',
        responsable: null,
        offices: true,
        groupUserReasign: 4,
        groupCounterGestion: 4,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, {
                Header: 'Fecha creación',
                accessor: 'gestionsolicitud.fecha_creacion',
            });
            cols.splice(7, 0, ResponsableWithTooltip);
            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'desistidas',
        label: 'DESISTIDAS',
        status: '80',
        responsable: null,
        offices: true,
        groupUserReasign: 5,
        groupCounterGestion: 5,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, {
                Header: 'Fecha desistimiento',
                accessor: 'gestionsolicitud.fecha_desistimiento',
            });
            cols.splice(7, 0, AmountRequest);
            cols.splice(8, 0, AnalistWithTooltip);
            cols.splice(9, 0, ApproverWithTooltip);
            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'aprobadas_directos_riesgos',
        label: 'APROBADAS',
        status: '50,60',
        responsable: null,
        offices: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, {
                Header: 'Fecha aprobación',
                accessor: 'gestionsolicitud.fecha_comite',
            });
            cols.splice(7, 0, AmountRequest);
            cols.splice(8, 0, AnalistWithTooltip);
            cols.splice(9, 0, ApproverWithTooltip);
            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },

    {
        id: 'desembolsadas_director_riesgos',
        label: 'DESEMBOLSADAS',
        status: '90',
        responsable: null,
        offices: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, {
                Header: 'Fecha desembolso',
                accessor: 'gestionsolicitud.fecha_desembolso',
            });
            cols.splice(7, 0, AmountRequest);
            cols.splice(8, 0, AnalistWithTooltip);
            cols.splice(9, 0, ApproverWithTooltip);
            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'rechazadas_director_riesgos',
        label: 'RECHAZADAS',
        status: '70',
        responsable: null,
        offices: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, {
                Header: 'Fecha rechazo',
                accessor: 'gestionsolicitud.fecha_rechazo',
            });
            cols.splice(7, 0, AnalistWithTooltip);
            cols.splice(8, 0, ApproverWithTooltip);
            cols.push(CausalRequest);
            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
